/* eslint-disable react/prop-types */
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useState } from 'react';
import classes from './Tab2.module.css';

import StoreDialog from './StoreDialog';

import 'react-loading-skeleton/dist/skeleton.css';

export function ConnectionCardSkeleton({ cxname = '', css = {} }) {
  return (
    <div className={cx([classes.main_card], cxname)} style={css}>
      <Skeleton containerClassName={classes.mod_title} style={{ height: '100%', width: '100%' }} />
      <div className={classes.mod_content}>
        <Skeleton containerClassName={classes.mod_img} style={{ height: '100%', width: '100%' }} />
        <div className={classes.mod_info}>
          <div className={classes.mod_platform_name}>
            <Skeleton style={{ height: '100%', width: '50%' }} />
          </div>
          <div className={classes.mod_platform_info}>
            <Skeleton style={{ height: '100%', width: '60%' }} />
          </div>
        </div>
      </div>
    </div>
  );
}

function StoreConnectionCard({
  data, isLoading, clickHandler,
}) {
  if (isLoading) {
    return <ConnectionCardSkeleton />;
  }
  const [open, setOpen] = useState(false);
  const {
    connected, name, icon, info, emptyText, buttonText,
  } = data || {};
  // const isAPI = /(Gently|Treet|Garmentory)/.test(name);
  return (
    <div className={classes.store}>
      {
        connected
          ? (
            <div className={classes.store_wrapper}>
              <img src={icon} className={classes.store_mod_img} alt="" />
              <div className={classes.store_mod_info}>
                <div>{name}</div>
                <div className={classes.store_mod_email}>{info}</div>
              </div>
              {/* {isAPI && (
                <>

                  <div className={classes.store_tag_api}>API</div>
                  <div className={classes.store_api_key} onClick={() => setOpen(true)}>API key</div>
                </>
              )} */}

            </div>
          )
          : (
            <div className={classes.connect_store}>
              <div className={classes.disable_text}>{emptyText}</div>
              <div style={{ display: 'flex', flex: 1 }} />
              <div
                className={classes.connect_button}
                onClick={clickHandler}
              >
                {buttonText}
              </div>
            </div>
          )
      }
      <StoreDialog open={open} handleClose={() => setOpen(false)} />
    </div>
  );
}

export default StoreConnectionCard;

StoreConnectionCard.proptype = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    connected: PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      info: PropTypes.string.isRequired,
    }),
    empty: PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      info: PropTypes.string.isRequired,
      clickHandler: PropTypes.func.isRequired,
      emptyText: PropTypes.string.isRequired,
      buttonText: PropTypes.string.isRequired,
    }),
  }),
};
